module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [(_vm.getReverseInvoiceDashList.length > 0) ? _c('b-button', {
    staticClass: "pull-right mb-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getAllBillingInvList', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "id": "show-btn",
      "size": "xs",
      "variant": 'info'
    },
    on: {
      "click": function($event) {
        _vm.addInv()
      }
    }
  }, [_vm._v("\n            Add Inv DOc\n            "), _c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search "
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": function($event) {
        _vm.filterClear();
        _vm.clearFilter();
      }
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "opens": _vm.openRight,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": _vm.debounceSearch
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": function($event) {
        _vm.debounceSearch();
        _vm.clearBranch();
      }
    },
    model: {
      value: (_vm.Filter.clientIdFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientIdFilter", $$v)
      },
      expression: "Filter.clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "BranchFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.BranchFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "BranchFilter", $$v)
      },
      expression: "Filter.BranchFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.getReverseInvoiceDashList,
      "responsive": "",
      "fields": _vm.Columns,
      "primary-key": "id_email_section",
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "InvNO",
      fn: function(row1) {
        return [(row1.item.inv_doc_folder_name && row1.item.inv_doc_url) ? _c('b', [_c('u', [_c('a', {
          style: (row1.item.inv_doc_folder_name && row1.item.inv_doc_url ?
            'color: blue' :
            'color: black'),
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              row1.item.inv_doc_folder_name && row1.item.inv_doc_url ?
                _vm.openSignedDocument(
                  ("ASSIGNMENT_UPLOADS/" + (row1.item.inv_doc_folder_name) + "/" + (row1.item.inv_doc_url))
                ) :
                ''
            }
          }
        }, [_vm._v("Inv No : " + _vm._s(row1.item.InvNO))])])]) : _c('span', [_vm._v("Inv No : " + _vm._s(row1.item.InvNO))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Inv Date : " + _vm._s(row1.item.InvDate))]), _c('br'), _vm._v(" "), (_vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row1.item)
            }
          }
        }, [_vm._v("Summary & Documents")]) : _vm._e(), _vm._v(" "), (row1.item.fk_all_module_id) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Job No - ' + row1.item.JOBNO,
            "PMC_JOBID": row1.item.fk_all_module_id,
            "PMC_JOBNO": row1.item.JOBNO,
            "PMC_JOBDATE": _vm._f("moment")(row1.item.JOBDate),
            "PMC_JOBTYPE": row1.item.JobType,
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.fk_all_module_id) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row1.item.JOBNO,
            "PMC_JOBID": row1.item.fk_all_module_id,
            "PMC_JOBNO": row1.item.JOBNO,
            "PMC_JOBDATE": _vm._f("moment")(row1.item.JOBDate),
            "PMC_JOBTYPE": row1.item.JobType,
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.fk_all_module_id) ? _c('JobWisePaymentsDetails', {
          attrs: {
            "allModuleId": Number(row1.item.fk_all_module_id),
            "JobNo": row1.item.JOBNO
          }
        }) : _vm._e()]
      }
    }, {
      key: "JOBNO",
      fn: function(row1) {
        return [_c('span', [_vm._v("Job No : " + _vm._s(row1.item.JOBNO))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Job Date : " + _vm._s(row1.item.JOBDate))])]
      }
    }, {
      key: "inv_doc_folder_name",
      fn: function(row1) {
        return [(row1.item.docSentBy) ? _c('span', [_vm._v("Sent By : " + _vm._s(row1.item.docSentBy)), _c('br')]) : _vm._e(), _vm._v(" "), (
          row1.item.inv_doc_sent_trough_email ||
          row1.item.inv_doc_sent_trough_courier
        ) ? _c('span', [_vm._v("Invoice Sent Through :\n                    " + _vm._s(row1.item.inv_doc_sent_trough_email +
          "/" +
          row1.item.inv_doc_sent_trough_courier)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.inv_doc_Docket_No) ? _c('span', [_vm._v("Docket No : " + _vm._s(row1.item.inv_doc_Docket_No)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.inv_doc_date_courier) ? _c('span', [_vm._v("\n                    Courier Date : " + _vm._s(row1.item.inv_doc_date_courier)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.inv_doc_date) ? _c('span', [_vm._v("\n                    Email Date : " + _vm._s(row1.item.inv_doc_date)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.inv_doc_remark) ? _c('span', [_vm._v("Remarks : " + _vm._s(row1.item.inv_doc_remark)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.inv_doc_folder_name && row1.item.inv_doc_url) ? _c('a', {
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              _vm.openSignedDocument(
                ("ASSIGNMENT_UPLOADS/" + (row1.item.inv_doc_folder_name) + "/" + (row1.item.inv_doc_url))
              )
            }
          }
        }, [_vm._v("--View")]) : _vm._e()]
      }
    }, {
      key: "InvType",
      fn: function(row2) {
        return [_c('b-button', {
          attrs: {
            "variant": "primary",
            "id": "uploadDoc"
          },
          on: {
            "click": function($event) {
              _vm.uploadDoc(row2.item)
            }
          }
        }, [_vm._v("Upload Doc")])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "5",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "rev_inv_doc_modal",
    attrs: {
      "id": "rev_inv_doc_modal",
      "title": 'Upload Reverse Doc - ' + _vm.DocJOBNO + ' / Inv No : ' + _vm.DocInvNO,
      "size": "lg",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_c('b', [_vm._v(" Sent By : ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "fk_inv_doc_sent_by",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    model: {
      value: (_vm.invoiceDocDeatils.fk_inv_doc_sent_by),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDocDeatils, "fk_inv_doc_sent_by", $$v)
      },
      expression: "invoiceDocDeatils.fk_inv_doc_sent_by"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Invoice Sent Through :")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox-inline"
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "checkbox-Email",
      "name": "checkbox-Email",
      "value": "Email",
      "unchecked-value": ""
    },
    model: {
      value: (_vm.invoiceDocDeatils.inv_doc_sent_trough_email),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDocDeatils, "inv_doc_sent_trough_email", $$v)
      },
      expression: "invoiceDocDeatils.inv_doc_sent_trough_email"
    }
  }, [_vm._v("\n            Email\n          ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "id": "checkbox-Courier",
      "name": "checkbox-Courier",
      "value": "Courier",
      "unchecked-value": ""
    },
    model: {
      value: (_vm.invoiceDocDeatils.inv_doc_sent_trough_courier),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDocDeatils, "inv_doc_sent_trough_courier", $$v)
      },
      expression: "invoiceDocDeatils.inv_doc_sent_trough_courier"
    }
  }, [_vm._v("\n            Courier\n          ")])], 1)]), _vm._v(" "), (_vm.invoiceDocDeatils.inv_doc_sent_trough_email == 'Email') ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Email Date :")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "amount",
      "name": "amount",
      "type": "date"
    },
    model: {
      value: (_vm.invoiceDocDeatils.inv_doc_date),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDocDeatils, "inv_doc_date", $$v)
      },
      expression: "invoiceDocDeatils.inv_doc_date"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.invoiceDocDeatils.inv_doc_sent_trough_courier == 'Courier') ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Docket No :")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "amount",
      "name": "amount",
      "type": "text"
    },
    model: {
      value: (_vm.invoiceDocDeatils.inv_doc_Docket_No),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDocDeatils, "inv_doc_Docket_No", $$v)
      },
      expression: "invoiceDocDeatils.inv_doc_Docket_No"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.invoiceDocDeatils.inv_doc_sent_trough_courier == 'Courier') ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Courier Date :")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "inv_doc_date_courier",
      "name": "inv_doc_date_courier",
      "type": "date"
    },
    model: {
      value: (_vm.invoiceDocDeatils.inv_doc_date_courier),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDocDeatils, "inv_doc_date_courier", $$v)
      },
      expression: "invoiceDocDeatils.inv_doc_date_courier"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Remarks :")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.invoiceDocDeatils.inv_doc_remark),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDocDeatils, "inv_doc_remark", $$v)
      },
      expression: "invoiceDocDeatils.inv_doc_remark"
    }
  })], 1), _vm._v(" "), (_vm.invoiceDocDeatils.doc_path && _vm.invoiceDocDeatils.inv_doc_url) ? _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Doc :")]), _vm._v(" "), _c('Single-Upload', {
    attrs: {
      "index": 0,
      "second_index": 0,
      "multiple": false,
      "documentName": 'ReverseTallyInv_Doc_',
      "otherDocName": 'ReverseTallyInv_Doc_',
      "folderName": _vm.invoiceDocDeatils.JOBNO,
      "accept": '*',
      "state": Boolean(_vm.invoiceDocDeatils.inv_doc_url),
      "assign_no": _vm.invoiceDocDeatils.JOBNO ? _vm.invoiceDocDeatils.JOBNO : 'INVOICE',
      "fileAllModuleId": _vm.invoiceDocDeatils.allModuleId
    },
    model: {
      value: (_vm.invoiceDocDeatils.inv_doc_url),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDocDeatils, "inv_doc_url", $$v)
      },
      expression: "invoiceDocDeatils.inv_doc_url"
    }
  }), _vm._v(" "), (_vm.invoiceDocDeatils.inv_doc_url_err) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.invoiceDocDeatils.inv_doc_url_err))]) : _vm._e(), _vm._v(" "), (_vm.invoiceDocDeatils.doc_path && _vm.invoiceDocDeatils.inv_doc_url) ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.openSignedDocument(
          ("ASSIGNMENT_UPLOADS/" + (_vm.invoiceDocDeatils.doc_path) + "/" + (_vm.invoiceDocDeatils.inv_doc_url))
        )
      }
    }
  }, [_vm._v("--View")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('center', [_c('b-button', {
    staticClass: "mt-2",
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "variant": "success",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.submitInvoiceDoc()
      }
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-2",
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.hideRevInvDoc
    }
  }, [_vm._v("Close")])], 1)], 1)])], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": 'Assignment Summary & Documents - ' + _vm.JOBSERIES
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n      ")])], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61b8a7f0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/invoice/billingInvList.vue
// module id = 2679
// module chunks = 0